import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/layouts/docs.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "change-fees",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#change-fees",
        "aria-label": "change fees permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Change fees`}</h1>
    <p>{`There are two settable fees in the Materia protocol:`}</p>
    <ul>
      <li parentName="ul"><em parentName="li">{`Swap fee`}</em>{` is the fee that a trader pays per hop (a swap can only make one or two hops), and the default value is 30 basis points (0.3%)`}</li>
      <li parentName="ul"><em parentName="li">{`Materia fee`}</em>{` is the part of `}<em parentName="li">{`swap fee`}</em>{` that goes to the Materia DFO (the receiver is `}<inlineCode parentName="li">{`feeTo`}</inlineCode>{`), the default value is 1/6.`}</li>
    </ul>
    <h2 {...{
      "id": "code-example",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#code-example",
        "aria-label": "code example permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Code example`}</h2>
    <p>{`This example changes the `}<inlineCode parentName="p">{`swap fee`}</inlineCode>{` and the `}<inlineCode parentName="p">{`Materia fee`}</inlineCode>{` for the pair WUSD-DAI.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-solidity"
      }}>{`function callOneTime(address) public {
  IMVDProxy dfoProxy = IMVDProxy(msg.sender);
  address daiToken = <daiAddress>;
  uint materiaFee = <materiaFee>;
  uint swapFee = <swapFee>;

  materiaOrchestrator.setFees(
    tokenDai,
    materiaFee,
    swapFee,
  ); 
}
`}</code></pre>
    <h1 {...{
      "id": "change-default-fees",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#change-default-fees",
        "aria-label": "change default fees permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Change default fees`}</h1>
    <p>{`It’s also possible to set the default `}<em parentName="p">{`swap fee`}</em>{` and `}<em parentName="p">{`Materia fee`}</em>{` i.e. the fees that are automatically set when the Materia Factory deploys a new pair.`}</p>
    <h2 {...{
      "id": "code-example-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#code-example-1",
        "aria-label": "code example 1 permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Code example`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-solidity"
      }}>{`function callOneTime(address) public {
  IMVDProxy dfoProxy = IMVDProxy(msg.sender);

  materiaOrchestrator.setDefaultFees(
    5, //Materia fee
    3, //Swap fee
  ); 
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      